import { request } from '@/utils/request';

const photoSpaceUrl: string = import.meta.env.VITE_SERVER_IMAGEURL;

/** 获取文件夹树 */
export function getFolderTree(data: API.GetFolderTreeParam) {
  return request<API.GetFolderTreeResponse>({
    url: `${photoSpaceUrl}/folder/getFolderTree`,
    method: 'get',
    params: data,
  });
}

/** 新建文件夹 */
export function addFolder(data: API.AddFolderParam) {
  return request<API.AddFolderResponse>({
    url: `${photoSpaceUrl}/folder/add`,
    method: 'post',
    data,
  });
}

/** 修改文件夹名 */
export function renameFolder(data: API.RenameFolderParam) {
  return request<API.RenameFolderResponse>({
    url: `${photoSpaceUrl}/folder/resetFolName`,
    method: 'post',
    data,
  });
}

/** 删除文件夹 */
export function deleteFolder(data: API.DeleteFolderParam) {
  return request<API.DeleteFolderResponse>({
    url: `${photoSpaceUrl}/folder/del`,
    method: 'post',
    data,
  });
}

/** 移动文件夹 */
export function moveFolder(data: API.MoveFolderParam) {
  return request<API.MoveFolderResponse>({
    url: `${photoSpaceUrl}/folder/move`,
    method: 'post',
    data,
  });
}

/** 获取文件夹详情 */
export function getFolderDetail(data: API.GetFolderDetailParam) {
  return request<API.GetFolderDetailResponse>({
    url: `${photoSpaceUrl}/folder/getFolderInfo`,
    method: 'get',
    params: data,
  });
}

/** 上传文件 */
export function addFile(data: API.AddFileParams) {
  const formData: FormData = new FormData();
  formData.append('p_id', data.p_id.toString());
  formData.append('file', data.file, data.fileName);
  return request<API.AddFileResponse>({
    url: `${photoSpaceUrl}/file/add`,
    method: 'post',
    data: formData,
  });
}

/** 搜索文件 */
export function searchFile(data: API.SearchFileParam) {
  return request<API.SearchFileResponse>({
    url: `${photoSpaceUrl}/search`,
    method: 'get',
    params: data,
  });
}

/** 修改文件名 */
export function renameFile(data: API.RenameFileParam) {
  return request<API.RenameFileResponse>({
    url: `${photoSpaceUrl}/file/setName`,
    method: 'post',
    data,
  });
}

/** 删除文件 */
export function deleteFile(data: API.DeleteFileParam) {
  return request<API.DeleteFileResponse>({
    url: `${photoSpaceUrl}/file/del`,
    method: 'post',
    data,
  });
}

/** 移动文件 */
export function moveFile(data: API.MoveFileParam) {
  return request<API.MoveFileResponse>({
    url: `${photoSpaceUrl}/file/move`,
    method: 'post',
    data,
  });
}

/** 生成白底图 */
export function generateWhiteBackgroundPicture(data: FormData) {
  return request<API.GenerateWhiteBackgroundPictureResponse>({
    url: `${photoSpaceUrl}/tool/mkBdt`,
    method: 'post',
    data,
  });
}

/** 生成标题 */
export function generateTitleFromPicture(data: FormData) {
  return request<API.GenerateTitleResponse>({
    url: `${photoSpaceUrl}/goods/getGoodsTjTitlesFormFile`,
    method: 'post',
    data,
  });
}

/** 检查网盘链接 */
export function addForCat(data: API.AddForCatParam) {
  return request<API.AddForCatResponse>({
    url: `${photoSpaceUrl}/folder/addForCat`,
    method: 'post',
    data,
  });
}
